export default "__VITE_ASSET__DuXG724b__"